var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5588 10.0882C14.0987 8.22549 15.6148 6.36275 17.1073 4.5C20.0358 5.2451 21.5 7.10784 21.5 10.0882M12.5588 10.0882H5.29413C5.9827 14.5588 8.80088 16.7941 13.7487 16.7941C18.6965 16.7941 21.2802 14.5588 21.5 10.0882M12.5588 10.0882H21.5M9.28036 16.2353C10.2062 16.2353 10.9568 16.9859 10.9568 17.9118C10.9568 18.8377 10.2062 19.5882 9.28036 19.5882C8.35447 19.5882 7.60389 18.8377 7.60389 17.9118C7.60389 16.9859 8.35447 16.2353 9.28036 16.2353ZM18.2215 16.2353C19.1474 16.2353 19.898 16.9859 19.898 17.9118C19.898 18.8377 19.1474 19.5882 18.2215 19.5882C17.2956 19.5882 16.5451 18.8377 16.5451 17.9118C16.5451 16.9859 17.2956 16.2353 18.2215 16.2353Z",
    stroke: "#22222D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5588 10.0882C14.0987 8.22549 15.6148 6.36275 17.1073 4.5C20.0358 5.2451 21.5 7.10784 21.5 10.0882M12.5588 10.0882H5.29412C5.98269 14.5588 8.80087 16.7941 13.7487 16.7941C18.6965 16.7941 21.2802 14.5588 21.5 10.0882M12.5588 10.0882H21.5M2.5 5.61765H4.73529L6.41176 10.0882M9.28035 16.2353C10.2062 16.2353 10.9568 16.9859 10.9568 17.9118C10.9568 18.8377 10.2062 19.5882 9.28035 19.5882C8.35446 19.5882 7.60388 18.8377 7.60388 17.9118C7.60388 16.9859 8.35446 16.2353 9.28035 16.2353ZM18.2215 16.2353C19.1474 16.2353 19.898 16.9859 19.898 17.9118C19.898 18.8377 19.1474 19.5882 18.2215 19.5882C17.2956 19.5882 16.5451 18.8377 16.5451 17.9118C16.5451 16.9859 17.2956 16.2353 18.2215 16.2353Z",
    stroke: "#22222D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby);
export default __webpack_public_path__ + "static/media/baby.46b66663.svg";
export { ForwardRef as ReactComponent };